// AUTO-GENERATED from services/app-api-service/codeigniter/application/contracts/FranchisorChannels_MessagesQueryInput.php
// Do not edit by hand — edit the PHP InputContract and the sync hook will regenerate this file.
// Bulk regeneration: scripts/sync-contracts/sync-all.sh

/**
 * FranchisorChannels_MessagesQueryInput — query string for
 * GET /franchisor-channels/messages.
 *
 * `limit` is clamped by the controller to [1, 100] — this contract accepts
 * any int (or null → controller default) and leaves the hard cap to the
 * single MESSAGES_MAX_LIMIT constant so the ceiling lives in one place.
 */
import { registerContract } from './validate'

export interface FranchisorChannels_MessagesQueryInput {
trigger_key?: string
status?: string
limit?: number
}

registerContract('FranchisorChannels_MessagesQueryInput', {
  trigger_key: { type: 'string',  required: false },
  status:      { type: 'string',  required: false },
  limit:       { type: 'number',  required: false },
})
